<template>
  <div class="invoices-links">
    <template v-for="(item, i) in invoicesData">
      <InvoicesLinks
        v-if="(i + 1) <= quantityShowInvoices"
        :item="item"
        :templates="templates"
        :key="`total-${i + 1}`"
        @reloadInvoices="reloadInvoices"
      />
    </template>
    <span
      v-if="invoicesData.length > quantityShowInvoices"
      class="material-icons icon-image-preview invoice-more"
      @click="$bvToast.show(`${invoiceKey}-invoices`)"
    >
      more_vert
    </span>

    <b-toast :class="invoiceModalClass" :id="`${invoiceKey}-invoices`" :title="`Invoices for ${invoiceKey}`" static no-auto-hide>
      <template v-for="(item, i) in invoicesData">
        <InvoicesLinks
          :item="item"
          :templates="templates"
          :key="`total-${i + 1}`"
          @reloadInvoices="reloadInvoices"
        />
      </template>
    </b-toast>
  </div>
</template>

<script>
import InvoicesLinks from './InvoicesLinks'
export default {
  components: { InvoicesLinks },
  props: {
    templates: {
      type: Array
    },
    invoiceKey: {
      type: String,
      default: ''
    },
    invoicesData: {
      type: Array,
      default: () => ([])
    },
    quantityShowInvoices: {
      type: Number,
      default: 2
    },
    invoiceModalClass: {
      type: String,
      default: ''
    }
  },
  methods: {
    reloadInvoices () {
      this.$emit('reloadInvoices')
    }
  }
}
</script>

<style lang="scss" scoped>
.invoices-links {
  display: flex;
  justify-content: center;
  align-items: center;
  .b-toast {
    position: absolute;
  }
  .invoice-more {
    height: 100%;
    color: #007bff;
    cursor: pointer;
  }
}
</style>
